import _toConsumableArray from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { reactive } from "@vue/reactivity";
import { getArchiveCountList } from "../api/archive";
export default {
  name: "KilaKilaArchiveCard",
  setup: function setup() {
    var archiveCounts = reactive([]);
    getArchiveCountList(1, 100).then(function (data) {
      archiveCounts.push.apply(archiveCounts, _toConsumableArray(data.rows));
    });
    return {
      archiveCounts: archiveCounts
    };
  }
};